import { Checkbox, Col, Row } from 'antd';
import styled from 'styled-components';

export const ButtonContainer = styled.button<{ isActive?: boolean }>`
  display: flex;
  background: none;
  padding: 0;
  margin: 0;
  width: 100%;
  cursor: pointer;

  border: ${({ isActive }) =>
    isActive ? '1px solid #00ab6b' : '1px solid #ededed'};
  border-radius: 4px;
  padding: 16px;

  transition: 0.15s ease-out border;
`;

export const BoxRow = styled(Row)`
  width: 100%;
`;

export const IconCol = styled(Col)`
  height: 20px;
`;

export const MethodCheckbox = styled(Checkbox)`
  & .ant-checkbox-inner,
  & .ant-checkbox-checked::after {
    border-radius: 8px;
  }
`;
